<template>
  <section class="section">
    <div class="section-wrap">
      <img src="@/assets/img/home/hero.png" />
      <div class="content observer-selector">
        <div class="title-wrap">
          <div class="title">
            당신의 시간을 <br />
            가치있게
          </div>
          <div class="sub-title">나에게 Fit한 배송, 디버</div>
        </div>
        <div class="button-wrap">
          <button @click="moveOrder" class="primary">주문접수</button>
          <button @click="moveList" class="primary-soft">주문내역</button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  methods: {
    moveOrder() {
      this.$router.push("/orders/form");
    },
    moveList() {
      this.$router.push("/orders/list/my");
    }
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters["auth/isAuthenticated"]();
    }
  }
};
</script>

<style scoped src="../home.common.css"></style>
<style scoped>
.section {
  width: 100%;
  min-height: 100vh;

  background: linear-gradient(180deg, #dae7f3 0%, #eff2f5 100%);

  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.content {
  z-index: 4;
  position: absolute;
}

.section-wrap {
  width: 100%;
  height: max-content;
  display: flex;
  justify-content: center;
  overflow: hidden;
}

.section-wrap > img {
  min-height: 100%;
  width: 100%;
  min-width: 1440px;
  /* position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-sizing: border-box; */
}

.title-wrap {
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 238px;
}

.title {
  color: var(--gray-700);
  font-size: 46px;
  font-weight: 700;
  line-height: 130%;
}

.sub-title {
  color: var(--gray-500);
  font-size: 24px;
  font-weight: 500;
  line-height: 32px;
}

.button-wrap {
  display: grid;
  justify-content: center;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  padding: 64px 12px 0px;
  margin-top: 32px;
}

button {
  width: 100%;
}

@media (min-width: 1024px) {
  .title-wrap {
    gap: 32px;
  }
  .title {
    font-size: 74px;
    line-height: 127.5%;
  }
  .button-wrap {
    gap: 20px;
  }
  button {
    width: 192px;
  }
}
</style>
